import { LabelBadgeContainer } from './LabelBadge.styled'

interface ILabelBadgeProps {
  color: string
  children: React.ReactNode
  backgroundColor?: string
  width?: string
  onClick?: (e: React.MouseEvent) => void
}

export const LabelBadge = ({ color, children, backgroundColor, width, onClick }: ILabelBadgeProps) => (
  <LabelBadgeContainer
    $color={color}
    $backgroundColor={backgroundColor}
    $width={width}
    $clickable={Boolean(onClick)}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
  >
    {children}
  </LabelBadgeContainer>
)
